import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Types — alinhados com Response.Ouvidoria / Response.Ouvidoria.Compacta (OpenAPI)
export interface OuvidoriaMinima {
  id: string;
  cnpj: string;
  nome: string;
}

export interface Ouvidoria {
  id: string;
  cnpj: string;
  nome: string;
  razaoSocial: string;
  nomeFantasia: string;
  naturezaJuridica: string;
  atividadePrincipal?: string | null;
  endereco: string;
  municipio: string;
  uf: string;
  telefone: string;
  email: string;
  website?: string;
  logo?: string;
  // Hierarquia (hierarquia-ouvidorias.md)
  geral: boolean;
  supervisoraId?: string | null;
  supervisora?: OuvidoriaMinima | null;
  associacaoSupervisora?: boolean;
  instituicao?: string | null;
  etiquetas?: string[] | null;
  arquivada?: boolean;
  // "Aguardando Aprovação" | "Aprovada" | "Reprovada"
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface OuvidoriaState {
  // Auth State (sessão persistida; autenticação real via autenticacaoService)
  isAuthenticated: boolean;
  currentOuvidoria: Ouvidoria | null;
  token: string | null;

  error: string | null;

  // Actions
  setSession: (ouvidoria: Ouvidoria, token: string) => void;
  setOuvidoria: (ouvidoria: Ouvidoria) => void;
  logout: () => void;
  clearErrors: () => void;
}

export const useOuvidoriaStore = create<OuvidoriaState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      currentOuvidoria: null,
      token: null,
      error: null,

      setSession: (ouvidoria, token) =>
        set({ isAuthenticated: true, currentOuvidoria: ouvidoria, token, error: null }),

      setOuvidoria: (ouvidoria) => set({ currentOuvidoria: ouvidoria }),

      logout: () =>
        set({
          isAuthenticated: false,
          currentOuvidoria: null,
          token: null,
          error: null,
        }),

      clearErrors: () => set({ error: null }),
    }),
    {
      name: 'urbnet-ouvidoria-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        currentOuvidoria: state.currentOuvidoria,
        token: state.token,
      }),
    }
  )
);
